enum UPLOAD_TYPE {
  MANUFACTURE = "MANUFACTURE",
}

enum STATUS {
  BLOCKED = "BLOCKED",
  UN_BLOCKED = "UN_BLOCKED",
  ACTIVATED = "ACTIVATED",
  DEACTIVATED = "DEACTIVATED",
  DELETED = "DELETED",
  SCHEDULED = "SCHEDULED",
  SENT = "SENT",
  ARCHIVED = "ARCHIVED",
  ACTIVE = "ACTIVE",
}

enum EMPLOYEE_ROLE {
  PACKAGING = "PACKAGING",
  FACILITY_ADMIN = "FACILITY_ADMIN",
  NON_PLANT_TOUCHING = "NON_PLANT_TOUCHING",
  PLANT_TOUCHING = "PLANT_TOUCHING",
}

enum USER_TYPE {
  ADMIN = "ADMIN",
  ADMIN_EMPLOYEE = "ADMIN_EMPLOYEE",
}

enum MANUFACTURER_TYPE {
  MANUFACTURER_USER = "MANUFACTURER_USER",
  MANUFACTURER_EMPLOYEE = "MANUFACTURER_EMPLOYEE",
}

enum REWARD_TYPE {
  PHYSICAL_MERCHANDISE = "Physical Marchandise",
  PERCENTAGE_DISCOUNT = "Percentage Discount",
  CONCERT_TICKET = "Concert Ticket",
}

enum STRAIN_TYPE {
  INDICA = "Indica",
  SATIVA = "Sativa",
  HYBRID = "Hybrid",
  INDICA_DOMINANT_HYBRID = "Indica-Dominant Hybrid",
  SATIVA_DOMINANT_HYBRID = "Sativa-Dominant Hybrid",
}

enum FEELINGS_TYPE {
  CALMING = "Calming",
  ENERGIZED = "Energized",
  EUPHORIC = "Euphoric",
  FOCUSED = "Focused",
  FULL_BODY_HIGH = "Full Body High",
  HAPPY = "Happy",
  INVIGORATING = "Invigorating",
  PAIN_RELIEF = "Pain Relief",
  RELAXING = "Relaxing",
  SLEEPY = "Sleepy",
  STRESS_RELIEF = "Stress Relief",
  UPLIFTING = "Uplifting",
}

enum RIBBON_CRITERIA {
  COLLECT_PRODUCT = "Collect product",
  PROVIDE_REVIEW = "Provide Review",
  PROVIDE_STAR_RATING = "Provide Star Rating",
}

enum IMPORT_TYPE {
  IMPORT = "IMPORT",
}

enum QR_QUANTITY_STATUS_TYPE {
  AVAILABLE = "AVAILABLE",
  EXHAUSTED = "EXHAUSTED",
}

enum API_CONNECTION_SOFTWARE {
  METRC_CONNECT = "METRC_CONNECT",
  LIMS = "LIMS",
  NORDIC_ANALYTICAL = "NORDIC_ANALYTICAL",
}

enum ACCOUNT_STATUS {
  VERIFIED = "verified",
  UNVERIFIED = "unverified",
}

enum VERIFICATION_POPUP_TYPE {
  ADD = "Add",
  UPDATE = "Update",
  VERFIY = "Verify",
}

enum ASSOCIATE_TYPES {
  IMPORT = "IMPORT",
  CSV = "NEW_STRAIN",
}

enum TXN_STATUS {
  PENDING = "PENDING",
  SUCCESS = "SUCCESS",
}

enum TXN_TYPE {
  CREATE_NFT_CONTRACT = "create_nft_contracts",
  TOKENIZE_CERTIFICATE = "tokenize_certificate",
  INITIAL_MINT = "initial_mint",
  CLAIM_PRODUCT = "claim_product",
  UPDATE_OWNER = "update_owner",
  WITHDRAW_FUNDS = "withdraw_funds",
}

enum TXN_MODE {
  ACCOUNT_ABSTRACTION = "account_abstraction",
  ADMIN_WALLET = "admin_wallet",
}

enum COA_STATUS {
  PASS = "PASS",
  FAILED = "FAILED",
  COMPLETED = "COMPLETED",
}

enum SUBSCRIPTION_PLAN {
  BASIC = "basic",
  PREMIUM = "premium",
}

enum NON_TOKENIZED_BATCH_STATUS {
  ARCHIVE = "Archive",
}

enum ZENDESK_IDS {
  BRANDSPLATFORM = "42555096589971",
  BROWSER = "42504998359571",
  DEVICEMANUFACTURER = "42504866028691",
  DEVICETYPE = "42504524989331",
  LOGGEDIN = "42503847160339",
  SUPPORTREASON = "41546925688595",
  OPERATING_SYSTEM = "43210825562515",
}

enum LABEL_TYPE {
  DATABIS = "Databis Labels",
  PRINTONDEMAND = "Print-On-Demand Labels",
}

enum PRINTONDEMAND_TYPE {
  PRINT_ON_DEMAND = "PRINT_ON_DEMAND",
}

export {
  STATUS,
  TXN_TYPE,
  TXN_MODE,
  USER_TYPE,
  COA_STATUS,
  LABEL_TYPE,
  TXN_STATUS,
  UPLOAD_TYPE,
  REWARD_TYPE,
  STRAIN_TYPE,
  IMPORT_TYPE,
  ZENDESK_IDS,
  FEELINGS_TYPE,
  EMPLOYEE_ROLE,
  ACCOUNT_STATUS,
  ASSOCIATE_TYPES,
  RIBBON_CRITERIA,
  SUBSCRIPTION_PLAN,
  MANUFACTURER_TYPE,
  API_CONNECTION_SOFTWARE,
  QR_QUANTITY_STATUS_TYPE,
  VERIFICATION_POPUP_TYPE,
  NON_TOKENIZED_BATCH_STATUS,
  PRINTONDEMAND_TYPE,
};
